<div class="comment-widgets">
    <!--Store Names -->
    <div *ngIf="source?.length">
        <div class="text-center border-bottom">
            <p class="p-b-20" style="font-size: 20px;">
                <b *ngIf="title == ''">
                    Lugares de canje:
                </b>
                <b *ngIf="title != ''">
                    <i class="mdi mdi-storefront-outline text-dark" style="font-size: 1.1rem;"></i>
                    {{title}}:
                </b>
            </p>
        </div>

        <!-- List -->
        <div class="row">
            <div class="col-6" *ngFor="let sourceItem of source; let i = index" >
                <!-- Se muestran todas las tiendas normales -->
                <div *ngIf="source.length < 4 || i <= 3" class="cursor-pointer comment-row" (click)="onViewStore(storeModal, sourceItem)">
                    <div class="d-flex" >
                        <div class="w-100" [ngClass]="{'d-flex align-items-center' : sourceItem.phone.length <= 0}">
                            <div class="font-bold">
                                <i class="mdi mdi-storefront-outline text-dark mr-2" style="font-size: 1.1rem;"></i>
                                <span class="font-16 font-bold"><b>{{sourceItem.name}}</b></span>
                            </div>
                            <div *ngIf="sourceItem.phone" class="font-14">
                                <i class="mdi mdi-phone-outline text-dark mr-1" style="font-size: 1.1rem;"></i>
                                <b>Teléfono: </b> <span>{{sourceItem.phone | mask: '0000-0000'}}</span>
                            </div>
                        </div>
                        <div>
                            <i class="mdi mdi-chevron-right font-30"></i>
                        </div>
                    </div>
                </div>
                <div *ngIf="showAllStores && i > 3" class="cursor-pointer comment-row" (click)="onViewStore(storeModal, sourceItem)">
                    <div class="d-flex" >
                        <div class="w-100" [ngClass]="{'d-flex align-items-center' : sourceItem.phone.length <= 0}">
                            <div class="font-bold">
                                <i class="mdi mdi-storefront-outline text-dark mr-2" style="font-size: 1.1rem;"></i>
                                <span class="font-c1"><b>{{sourceItem.name}}</b></span>
                            </div>
                            <div *ngIf="sourceItem.phone" class="font-c1">
                                <i class="mdi mdi-phone-outline text-dark mr-1" style="font-size: 1.1rem;"></i>
                                <b>Teléfono: </b> <span>{{sourceItem.phone | mask: '0000-0000'}}</span>
                            </div>
                        </div>
                        <div>
                            <i class="mdi mdi-chevron-right font-30"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div *ngIf="source?.length > 4" class="d-flex-center text-center" (click)="validAllStore()">
                    <p *ngIf="showAllStores" class="font-c1 cursor-pointer m-t-20"><u>Ocultar los lugares de canje</u></p>
                    <p *ngIf="!showAllStores" class="font-c1 cursor-pointer m-t-20"><u>Mostrar todos los lugares de canje</u></p>
                </div>
            </div>
        </div>  
    </div>
</div>


<ng-template #storeModal let-modal>
    <div class="modal-body">

        <div>
            <button class="close" (click)="modal.dismiss()" style="margin-top: 13px;">
                <i class="mdi mdi-window-close font-18 font-bold"></i>
            </button>
        </div>

        <div class="border-bottom">
            <div class="text-center m-b-8 m-t-8 m-l-10 font-h4">
                {{storeSelected?.name}}
            </div>
        </div>

        <div class="p-b-20">

            <div class="m-t-10 p-b-10" 
            [ngClass]="{'border-bottom' : storeSelected?.phone || storeSelected?.whatsappPhone || storeSelected?.otherPhone || storeSelected?.addressDetails}">
                <span class="font-c1" [innerHTML]="storeSelected.vendor?.businessDescription"></span>
            </div>

            <div *ngIf="storeSelected?.addressDetails" class="m-t-10 p-b-10 border-bottom">
                <i class="mdi mdi-map-marker-outline text-primary m-r-10"></i>
                <span class="font-bold font-c1 m-r-10">Dirección:</span>
                <span class="font-c1">{{storeSelected?.addressDetails}}</span>
            </div>

            <div *ngIf="storeSelected?.phone || storeSelected?.whatsappPhone || storeSelected?.otherPhone" class="m-t-10 p-b-10 border-bottom">
                <div *ngIf="storeSelected?.phone">
                    <i class="mdi mdi-phone-outline text-primary m-r-10"></i>
                    <span class="font-bold font-c1 m-r-10">Teléfono: </span>
                    <span class="font-c1">{{storeSelected?.phone | mask: '0000-0000'}}</span>
                </div>
                <div *ngIf="storeSelected?.whatsappPhone">
                    <i class="mdi mdi-whatsapp text-primary m-r-10"></i>
                    <span class="font-bold font-c1 m-r-10">Whatsapp:</span>
                    <span class="font-c1">{{storeSelected?.whatsappPhone | mask: '0000-0000'}}</span>
                </div>
                <div *ngIf="storeSelected?.otherPhone">
                    <i class="mdi mdi-phone-outline text-primary m-r-10"></i>
                    <span class="font-bold font-c1 m-r-10">Otro:</span>
                    <span class="font-c1">{{storeSelected?.otherPhone | mask: '0000-0000'}}</span>
                </div>
            </div>

            <div *ngIf="storeSelected.type == 0" class="m-t-10"><!-- exchange -->
                <i class="mdi mdi-clock-outline text-primary m-r-10"></i>
                <span class="font-bold font-c1">Horarios:</span> 
                <div class="font-c1 m-l-25">
                    Lunes: <b>{{ getFormattedStoreHours(storeSelected.mondayStartAt, storeSelected.mondayEndAt) }}</b><br>
                    Martes: <b>{{ getFormattedStoreHours(storeSelected.tuesdayStartAt, storeSelected.tuesdayEndAt) }}</b> <br> 
                    Miercoles: <b>{{ getFormattedStoreHours(storeSelected.wednesdayStartAt, storeSelected.wednesdayEndAt) }}</b> <br> 
                    Jueves: <b>{{ getFormattedStoreHours(storeSelected.thursdayStartAt, storeSelected.thursdayEndAt) }}</b> <br> 
                    Viernes: <b>{{ getFormattedStoreHours(storeSelected.fridayStartAt, storeSelected.fridayEndAt) }}</b> <br> 
                    Sábados: <b>{{ getFormattedStoreHours(storeSelected.saturdayStartAt, storeSelected.saturdayEndAt) }}</b> <br>
                    Domingos: <b>{{ getFormattedStoreHours(storeSelected.sundayStartAt, storeSelected.sundayEndAt) }}</b> <br>
                </div>
            </div>

            <div *ngIf="storeSelected?.wazeLink" class="m-t-20 text-center w-100">
                <a class="btn btn-dark btn-wxl" [href]="storeSelected?.wazeLink" target="_blank" style="padding: 8px 40px;">
                    Abrir Waze
                </a>
            </div>
            <div class="font-14 text-muted text-center m-t-10 cursor-pointer" (click)="modal.dismiss()">Cerrar</div>
        </div>
    </div>
</ng-template>